import React, {
    useEffect,
    useState,
    useRef,
    Children,
    isValidElement,
    cloneElement
} from 'react';

const FadeIn = ({ children, delay = 0 }) => {
    const childrenArray = Children.toArray(children);

    return childrenArray.map((child, index) => {
        if (!isValidElement(child)) return child;

        // Если ты планируешь каскад внутри одного FadeIn (несколько детей) —
        // можно добавить сдвиг: const childDelay = delay + index * step.
        // Но в твоём случае ребёнок один, поэтому просто delay.
        return (
            <FadeItem
                key={index}
                child={child}
                delay={delay}   // ← передаём как есть
            />
        );
    });
};

export default FadeIn;


const FadeItem = ({ child, delay }) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                requestAnimationFrame(() => {
                    setTimeout(() => setIsVisible(true), delay);
                });
                observer.disconnect();
            }
        });

        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return cloneElement(child, {
        ref,
        className: `${child.props.className || ''} fade-in ${isVisible ? 'fade-active' : ''}`.trim(),
        style: {
            ...(child.props.style ?? {}),
            transitionDelay: `${delay}ms`,
            transitionProperty: 'opacity'  // Явно указать свойство
        }
    });

};

